<template>
  <div :id="pageName ? pageName : 'forecast'" class="mb-5">
    <ReportHeader
      :reportTypeId="reportTypeId"
      :title="title"
      :subtitle="subtitle"
    />
    <div class="row pb-5">
      <div class="col">
        <table
          :id="tableID"
          class="nowrap border-0"
          style="font-size: 15px; width: 100%"
        >
          <thead>
            <tr>
              <template
                v-for="(row, index) in forecastData.ForecastTable.Headers"
                :key="index"
              >
                <th class="tableHeader" style="background: #3075a4">
                  {{ row }}
                </th>
                <th
                  class="tableHeader"
                  style="background: #3075a4"
                  v-if="
                    (index === 1 && forecastData.ForecastRevised) ||
                    (monthEnd[index] === forecastData.FiscalYearEndMonth &&
                      forecastData.ForecastTable.Headers.length - 1 !== index)
                  "
                ></th>
              </template>
            </tr>
          </thead>
          <tbody>
            <template
              v-for="(row, index) in forecastData.ForecastTable.Rows"
              :key="index"
            >
              <tr>
                <td
                  class="fcBorderLeft"
                  :class="[
                    consulting_slug === 'market-forecast'
                      ? 'font-weight-bold'
                      : '',
                    aatk && index === 6
                      ? 'fcBorderBottomRadiusLeft fcBorderBottom'
                      : '',
                    aatk && (index === 2 || index === 5)
                      ? 'fcBorderBottomRadiusLeft fcBorderBottom'
                      : '',
                    aatk && (index === 3 || index === 6)
                      ? 'fcBorderTop fcBorderTopRadiusLeft'
                      : '',
                    row.RowTitle === 'Actual'
                      ? 'font-weight-bold fcActual fcBorderBottomRadiusLeft fcBorderBottom'
                      : '',
                    row.RowTitle.includes('Annual') ||
                    row.RowTitle.includes('Quarterly')
                      ? 'font-weight-bold fcAnnualRow'
                      : '',
                    index > 0 &&
                    forecastData.ForecastTable.Rows[index - 1].RowTitle ===
                      'Actual'
                      ? 'fcBorderTop fcBorderTopRadiusLeft'
                      : '',
                  ]"
                >
                  {{ row.RowTitle }}
                </td>

                <template v-for="(data, key) in row.ForecastColumns" :key="key">
                  <template v-if="key === 1 && forecastData.ForecastRevised">
                    <td class="noTableBorder">
                      <p
                        v-if="
                          (aatk && index === 4 && key === 1) ||
                          (!aatk && index === 6 && key === 1)
                        "
                        id="forecastRevisionText"
                        class="verticalText"
                      >
                        {{ forecastData.ForecastRevisedText }}
                      </p>
                    </td>
                  </template>
                  <template
                    v-else-if="
                      monthEnd[key] === forecastData.FiscalYearEndMonth &&
                      forecastData.ForecastTable.Headers.length - 1 !== key
                    "
                  >
                    <td
                      :class="[
                        aatk && index === 6 ? 'fcBorderBottom' : '',
                        aatk && (index === 3 || index === 6)
                          ? 'fcBorderTop'
                          : '',
                        aatk && (index === 2 || index === 5)
                          ? 'fcBorderBottom'
                          : '',
                        row.RowTitle === 'Actual'
                          ? 'actualColors fcActual font-weight-bold fcBorderBottom'
                          : '',
                        index > 0 &&
                        forecastData.ForecastTable.Rows[index - 1].RowTitle ===
                          'Actual'
                          ? 'fcBorderTop'
                          : '',
                        row.RowTitle.includes('Annual') ||
                        row.RowTitle.includes('Quarterly')
                          ? 'font-weight-bold fcAnnualRow'
                          : '',
                      ]"
                    ></td>
                  </template>

                  <td
                    class="text-center"
                    :class="[
                      aatk && index === 6 ? 'fcBorderBottom' : '',
                      aatk && (index === 3 || index === 6) ? 'fcBorderTop' : '',
                      aatk && (index === 2 || index === 5)
                        ? 'fcBorderBottom'
                        : '',
                      aatk &&
                      index === 6 &&
                      key === row.ForecastColumns.length - 1
                        ? 'fcBorderBottomRadiusRight'
                        : '',
                      aatk &&
                      (index === 3 || index === 6) &&
                      key === row.ForecastColumns.length - 1
                        ? 'fcBorderTopRadiusRight'
                        : '',
                      aatk &&
                      (index === 2 || index === 5) &&
                      key === row.ForecastColumns.length - 1
                        ? 'fcBorderBottomRadiusRight'
                        : '',
                      key === row.ForecastColumns.length - 1
                        ? 'fcBorderRight'
                        : '',
                      row.RowTitle === 'Actual'
                        ? 'actualColors fcActual font-weight-bold fcBorderBottom'
                        : '',
                      index > 0 &&
                      forecastData.ForecastTable.Rows[index - 1].RowTitle ===
                        'Actual'
                        ? 'fcBorderTop'
                        : '',
                      row.RowTitle === 'Actual' &&
                      key === row.ForecastColumns.length - 1
                        ? 'fcBorderBottomRadiusRight'
                        : '',
                      row.RowTitle.includes('Annual') ||
                      row.RowTitle.includes('Quarterly')
                        ? 'font-weight-bold fcAnnualRow'
                        : '',
                      index > 0 &&
                      forecastData.ForecastTable.Rows[index - 1].RowTitle ===
                        'Actual' &&
                      key === row.ForecastColumns.length - 1
                        ? 'fcBorderTopRadiusRight'
                        : '',
                    ]"
                  >
                    {{ data }}
                  </td>
                </template>
              </tr>

              <tr
                v-if="aatk && (index === 2 || index === 5)"
                :key="index"
                class="bg-white"
              >
                <td class="border-0 text-light" height="25px"></td>
                <template v-for="(data, key) in row.ForecastColumns" :key="key">
                  <template v-if="key === 1 && forecastData.ForecastRevised">
                    <td class="noTableBorder" height="25px"></td>
                  </template>
                  <template
                    v-else-if="
                      monthEnd[key] === forecastData.FiscalYearEndMonth &&
                      forecastData.ForecastTable.Headers.length - 1 !== key
                    "
                  >
                    <td class="border-0 text-light" height="25px"></td>
                  </template>

                  <td class="border-0 text-light" height="25px"></td>
                </template>
              </tr>
              <tr v-else-if="row.RowTitle === 'Actual'" class="bg-white">
                <td class="border-0 text-light" height="25px"></td>
                <template v-for="(data, key) in row.ForecastColumns" :key="key">
                  <template v-if="key === 1 && forecastData.ForecastRevised">
                    <td class="noTableBorder" height="25px"></td>
                  </template>
                  <template
                    v-else-if="
                      monthEnd[key] === forecastData.FiscalYearEndMonth &&
                      forecastData.ForecastTable.Headers.length - 1 !== key
                    "
                  >
                    <td class="border-0 text-light" height="25px"></td>
                  </template>

                  <td class="border-0 text-light" height="25px"></td>
                </template>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <div
        :class="
          aatk
            ? 'col-xx-large-4 col-x-large-6 pb-3'
            : 'col-xx-large-3 col-x-large-6 pb-3'
        "
      >
        <label class="cards" style="background: #87cff3">Outlook</label>
        <ul class="cardsList p-4 boxHeight">
          <li
            class="list1"
            v-for="(row, index) in forecastData.Outlook"
            v-bind:key="index"
          >
            {{ row }}
          </li>
        </ul>
      </div>
      <div
        :class="
          aatk
            ? 'col-xx-large-4 col-x-large-6 pb-3'
            : 'col-xx-large-3 col-x-large-6 pb-3'
        "
        v-if="!aatk"
      >
        <label class="cards" style="background: #5ab5a2">Results</label>
        <ul class="cardsList p-4 boxHeight">
          <li
            class="list2"
            v-for="(row, index) in forecastData.Results"
            v-bind:key="index"
          >
            {{ row }}
          </li>
        </ul>
      </div>
      <div
        :class="
          aatk
            ? 'col-xx-large-4 col-x-large-6 pb-3'
            : 'col-xx-large-3 col-x-large-6 pb-3'
        "
      >
        <label class="cards" style="background: #183961">
          Supporting Evidence
        </label>
        <ul class="cardsList p-4 boxHeight">
          <li
            class="list3"
            v-for="(row, index) in forecastData.Evidence"
            v-bind:key="index"
          >
            {{ row }}
          </li>
        </ul>
      </div>
      <div
        :class="
          aatk
            ? 'col-xx-large-4 col-x-large-6 pb-3'
            : 'col-xx-large-3 col-x-large-6 pb-3'
        "
      >
        <label class="cards" style="background: #006742">Risks</label>
        <ul class="cardsList p-4 boxHeight">
          <li
            class="list4"
            v-for="(row, index) in forecastData.Risks"
            v-bind:key="index"
          >
            {{ row }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  import ReportHeader from '~/components/report/ReportHeader.vue';
  export default {
    name: 'ForecastComponent',
    components: {
      ReportHeader,
    },
    props: {
      companyName: String,
      consulting_slug: String,
      forecastData: Object,
      monthEnd: Array,
      tableID: String,
      pageName: String,
      aatk: false,
      addon: false,
      is_market: Boolean,
      reportTypeId: {
        type: [String, Number],
        // required: true,
      },
    },
    computed: {
      title() {
        return `Forecast for ${this.forecastData.TableTitle}`;
      },
      subtitle() {
        return ``;
      },
    },
    mounted() {
      $('#' + this.tableID).DataTable({
        scrollX: true,
        dom: '<t>',
        // scrollCollapse: true,
        ordering: false,
        // autoWidth: true,
        // fixedHeader:true,
        paging: false,
        initComplete: (settings, json) => {
          // document.getElementById('forecastRevisionText').innerHTML = this.forecastData.ForecastRevisedText;
          if (this.forecastData.HideFirstColumn) {
            $('#' + this.tableID)
              .DataTable()
              .column(1)
              .visible(false);
          } else {
            // var actuals = $('#' + this.tableID + '.actualColors');
            let lmrIndex = 4;
            let umrIndex = 6;
            let actualIndex = 7;
            var lmr =
              this.forecastData.ForecastTable.Rows[lmrIndex].ForecastColumns[0];
            var umr =
              this.forecastData.ForecastTable.Rows[umrIndex].ForecastColumns[0];
            var actual =
              this.forecastData.ForecastTable.Rows[actualIndex]
                .ForecastColumns[0];

            if (lmr) lmr = parseFloat(lmr);
            if (umr) umr = parseFloat(umr);
            if (actual) actual = parseFloat(actual);
            if (actual >= lmr && actual <= umr) {
              $('#' + this.tableID + ' .actualColors').addClass('in-range');
            } else {
              $('#' + this.tableID + ' .actualColors').addClass('out-of-range');
            }
          }
        },
      });

      if (!this.is_market) {
        this.$emit('forecastLoaded');
      } else {
        this.$emit('forecastMarketIndexLoaded');
      }
    },
  };
</script>
